module.exports = __webpack_public_path__ + "img/vip-executive-santa-iria-hotel.bfc7cd7d.jpg";